import { render, staticRenderFns } from "./SilenceAllAlerts.vue?vue&type=template&id=9ba1d678"
import script from "./SilenceAllAlerts.vue?vue&type=script&lang=js"
export * from "./SilenceAllAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports